import { useState } from "react"
import DeletePopUP from "../../../../CommonPopUp/DeletePopUp"
import { useAuthDispatch, useAuthState } from "../../../../../Helper/Context/context"
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader"
import { useDispatch, useSelector } from 'react-redux';
import { FertilizerDeleteAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFiveSlice";


export const PlantsGrowthTable = (props) => {

    const { isLoading, PlantationDetailsPartFive, setPlantationDetailsPartFive, T_BeneficiaryPlantationDetailsID, M_BeneficiaryDetailsID, IsGrowthData, setIsGrowthData, setPlantsGrowth} = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })
    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }

    const handleIsGrowthData = () => {
        setIsGrowthData(!IsGrowthData)
        handleShowDelete()
        setPlantsGrowth('')
        
    }

    const handleDeleteData = () => {

        const data = {
            T_BeneficiaryPlantationDetailsID: T_BeneficiaryPlantationDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantsGrowth",
            token: token,
            handleIsFertilizerData: handleIsGrowthData
        }
        dispatch(FertilizerDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.FertilizerDeleteData)
    
    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}

            {
                PlantationDetailsPartFive[0].plantsGrowth && PlantationDetailsPartFive[0].plantsGrowth != '' ?

                    <div className="table-responsive p-0" >
                        <table className="table table-bordered">
                            <thead>
                                <tr className=" text-white">
                                    {/* <th className="text-center">Sr. No.</th> */}
                                    <th className="text-center"> Plants Growth</th>
                                    {/* <th className="text-center">Frequency for Fertilizer</th> */}
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {

                                    PlantationDetailsPartFive && PlantationDetailsPartFive.length > 0 ?
                                        PlantationDetailsPartFive.map((i, j) => {
                                            return (

                                                <tr>
                                                    
                                                    <td>
                                                        {i.plantsGrowth ? i.plantsGrowth : '-'}
                                                    </td>
                                                 

                                                    <td align="center">

                                                        <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                            onClick={() => handleShowDelete()}
                                                            title="Do you want to delete this record?"></i>
                                                    </td>

                                                </tr>


                                            )
                                        })
                                        :
                                        <span style={{ color: "red" }}>No data found</span>
                                }


                            </tbody>
                        </table>

                    </div>
                    :
                    ''
            }

            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }
        </div>
    )
}